import { reverse, sortBy } from 'lodash'

export const construireParts = (partParParametre, referentiel = [], palette = []) => {
  if (partParParametre == null) {
    return []
  }

  const parts = []
  const triees = new Map(sortBy(Object.entries(partParParametre), [(entree) => entree[1]]))
  let rang = 0

  triees.forEach((part, code) => {
    const parametre = (referentiel || []).find((valeur) => valeur.code === code)
    if (parametre == null) {
      return
    }
    parts.push({
      code: parametre.code,
      label: parametre.libelle,
      percentage: part,
      color: palette[rang]
    })
    rang++
  })

  return reverse(parts)
}

export default construireParts
